export { BaseExtension } from './baseExtension';

export type { Extension } from './types';
